module.exports = ".fas{\r\n    color: darkred;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/main/related-websites/related-websites.component.css
// module id = ./src/app/pages/main/related-websites/related-websites.component.css
// module chunks = main